<template>
    <div class="logged-out-layout">
        <RouterView />
    </div>
</template>

<style scoped lang="scss">
.logged-out-layout {
    min-height: 100vh;
    width: 100%;
}
</style>
